import { create } from 'zustand';
import {  createJSONStorage, persist } from 'zustand/middleware';
import { HomeFeedCardDefs, IHomeCardDef } from '../interface/feedHome';
import { IPlayListCardItem } from '../interface/playListCardItem';
import { IESSShortVideoActionData, IESShortVideoContent } from './iESShortVideoContentResponse';
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';
import { zustandHomeFeedStorage } from '../mmkv/mmkvHomeFeedPersistence';
import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';

type FeedStore = {
  longVideos: Array<IAdaptiveActionCard>;
  setLongVideos: (payload: Array<IAdaptiveActionCard>) => void;
  updateLongVideoCommentCount: (id: string, commentCount: string) => void;
  shortVideos: Array<IESSShortVideoActionData>;
  setShortVideos: (payload: Array<IESSShortVideoActionData>) => void;
  currentLongVideoSelected: IAdaptiveActionCard | null;
  currentLongVideoIndex: number;
  setLongVideoIndex: (index: number) => void;
  setLongVideoSelected: (selectedLongVideo?: IAdaptiveActionCard) => void;
  videoPlayList: Array<number>;
  setVideoPlayList: (list: Array<number>) => void;
  updateShortVideo: (shortVideo: IESShortVideoContent, index: number) => void;
  showReportBottomSheet: boolean;
  setShowReportBottomSheet: (show: boolean) => void;
  playList: IPlayListCardItem[];
  setPlayList: (payload: IPlayListCardItem[]) => void;
  transformLongVideosCard: IHomeCardDef<HomeFeedCardDefs>[];
  setTransformLongVideoCard: (payload: Array<IHomeCardDef<HomeFeedCardDefs>>) => void;
  languageChange: string;
  setLanguageChange: (change: string) => void;
  setActiveFeedItemIndex: (index: number) => void;
  getActiveFeedItemIndex: (state: FeedStore) => number;
  activeFeedItemIndex: number;
  resetFeedStore: () => void;
  findAndUpdateFeed: (index: number, newObject: IAdaptiveActionCard) => void;
  feedVideoMuteEnable: boolean;
  setFeedVideoMuteEnable: (show: boolean) => void;
  resetAutoPlayView: boolean;
  setResetAutoPlayView: (isExpanded: boolean) => void;
  homeFeedsCard: Array<IAdaptiveActionCard>;
  setHomeFeedsCard: (payload: Array<IAdaptiveActionCard>) => void;
  showNotififactionPopup: boolean;
  setShowNotififactionPopup: (show: boolean) => void;
};

const initialState = {
  longVideos: [],
  shortVideos: [],
  currentLongVideoIndex: 0,
  currentLongVideoSelected: null,
  videoPlayList: [],
  showReportBottomSheet: false,
  playList: [],
  transformLongVideosCard: [],
  languageChange: 'Hindi',
  activeFeedItemIndex: 0,
  feedVideoMuteEnable: true,
  resetAutoPlayView: false,
  homeFeedsCard: [],
  showNotififactionPopup: false,
};

export const useFeedStore = create<FeedStore>()(
  persist(
    (set, get) => ({
      longVideos: [],
      activeFeedItemIndex: 0,
      resetAutoPlayView: false,
      setActiveFeedItemIndex: (index: number) => {
        // if(get()?.activeFeedItemIndex === -1) {
        //   return;
        // }
        set(() => ({ activeFeedItemIndex: index }))
      },
      getActiveFeedItemIndex: (state: FeedStore) => state.activeFeedItemIndex,
      setLongVideos: (longVideos: Array<IAdaptiveActionCard>) =>
        set((state) => ({ longVideos: [...state.longVideos, ...longVideos] })),
      shortVideos: [],
      currentLongVideoIndex: 0,
      setLongVideoIndex: (index) => set(() => ({ currentLongVideoIndex: index })),
      setShortVideos: (shortVideos) => {
        set((state) => ({ shortVideos: [...shortVideos] }));
      },
      currentLongVideoSelected: null,
      setLongVideoSelected: (selectedLongVideo?: IAdaptiveActionCard) =>
        set(() => ({ currentLongVideoSelected: selectedLongVideo })),
      videoPlayList: get()?.videoPlayList ?? null,
      setVideoPlayList: (list: Array<number>) => set(() => ({ videoPlayList: list })),
      updateShortVideo: (shortVideo: IESShortVideoContent, index: number) => {
        const shortVideos = get()?.shortVideos;
        if (shortVideos[index]) {
          shortVideos[index].content = shortVideo;
          set(() => ({ shortVideos: shortVideos }));
        }
      },
      showReportBottomSheet: false,
      playList: [],
      setPlayList: (playList: IPlayListCardItem[]) => set(() => ({ playList: playList })),
      setShowReportBottomSheet: (show: boolean) => set(() => ({ showReportBottomSheet: show })),
      transformLongVideosCard: [],
      setTransformLongVideoCard: (payload: Array<IHomeCardDef<HomeFeedCardDefs>>) =>
        set((state) => ({
          transformLongVideosCard: [...state.transformLongVideosCard, ...payload],
        })),
      updateLongVideoCommentCount: (id: string, commentCount: string) => {
        // const findItem = get()?.longVideos.find((x) => x.id === id);
      },
      languageChange: 'Hindi',
      setLanguageChange: (change: string) => set(() => ({ languageChange: change })),
      resetFeedStore: () => set(() => initialState),
      findAndUpdateFeed: (index: number, newObject: IAdaptiveActionCard) => {
        const updateFeed = get()?.longVideos;
        updateFeed[index] = newObject;
        console.log('Find and update => ', updateFeed);
        set(() => ({ longVideos: updateFeed }));
      },
      feedVideoMuteEnable: true,
      setFeedVideoMuteEnable: (show: boolean) => set(() => ({ feedVideoMuteEnable: show })),
      setResetAutoPlayView: (resetAutoPlayView: boolean) => set(() => ({ resetAutoPlayView })),
      homeFeedsCard:[],
      setHomeFeedsCard: (homeFeedsCard: Array<IAdaptiveActionCard>) =>
        set(() => ({ homeFeedsCard })),
      showNotififactionPopup: false,
      setShowNotififactionPopup: (show: boolean) => set(() => ({ showNotififactionPopup: show })),
    }),

    {
      name: MMKVStoreKeyMap.feedStore,
      storage: createJSONStorage(() => zustandHomeFeedStorage),
      partialize: (state) => ({
        homeFeedsCard: state.homeFeedsCard,
        
      }),
    }
  )
);
